import Vue from "vue";
import { errorServeiceHandler, makeQueryStringDync } from "../../helper";

const actions = {
  actGetLogin: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryStringDync(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/login" + data, {
        method: "GET"
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveAgreementDetail: (context) => {
    return new Promise((resolve, reject) => {
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/termsandcondition", {
        method: "POST",
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          if (context.getters.getMode == "development") {
            resolve({ success: 26312908 })
            return
          }
          reject(error);
        });
    });
  },
  checkPortalMaintenance: (context) => {
    return new Promise((resolve, reject) => {
      fetch(context.getters.baseUrl + "/subscriber/v1/maintenance", {
        method: "GET",
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (context.getters.getMode == "development") {
            resolve({
              "maintenance": "OFF",
              "header": "Portal Maintenance",
              "image": "https://png.pngtree.com/thumb_back/fw800/background/20190813/pngtree-happy-ganesh-chaturthi-vector-banner-background-design-with-golden-color-gradient-image_299194.jpg",
              "content": "We clearly live in unprecedented times as Covid-19 is changing the world around us. Our thoughts and prayers are with everyone who is impacted. Now more than ever, we must come together as a community. With the uncertainty of the physical event happening this year, we decided to launch the first virtual event in response to the coronavirus lockdown. We would like to welcome you to Neotia Arts Trust’s new chapter — The India Story Continues… We will be hosting a Live web series of conversations, workshops, and performances from artists, designers, influencers, and many from all over India. Live events will be broadcasted every Saturday through the months of August, September, and October. It is complimentary and open to all and will be available on all our platforms — Youtube, Facebook, & our website. We are excited to continue creating, sharing, and learning with you all.",
              "style": ""
            })
            return
          } else {
            resolve(data);
          }
        })
        .catch(error => {
          if (context.getters.getMode == "development") {
            resolve({
              "maintenance": "OFF",
              "header": "Portal Maintenance",
              "image": "https://png.pngtree.com/thumb_back/fw800/background/20190813/pngtree-happy-ganesh-chaturthi-vector-banner-background-design-with-golden-color-gradient-image_299194.jpg",
              "content": "We clearly live in unprecedented times as Covid-19 is changing the world around us. Our thoughts and prayers are with everyone who is impacted. Now more than ever, we must come together as a community. With the uncertainty of the physical event happening this year, we decided to launch the first virtual event in response to the coronavirus lockdown. We would like to welcome you to Neotia Arts Trust’s new chapter — The India Story Continues… We will be hosting a Live web series of conversations, workshops, and performances from artists, designers, influencers, and many from all over India. Live events will be broadcasted every Saturday through the months of August, September, and October. It is complimentary and open to all and will be available on all our platforms — Youtube, Facebook, & our website. We are excited to continue creating, sharing, and learning with you all.",
              "style": ""
            })
            return
          }
          reject(error);
        });
    });
  }
};
export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/account/login.js